import {LocationTypes} from '@/src/hooks/useCountriesList';
import FilterRow from '@/src/Search/components/FilterRow';
import FilterByClinics from '@/src/Search/containers/FilterByClinics';
import JobTypesCheckboxes from '@/src/Search/containers/JobTypesCheckboxes';
import LocationsSelectFilter from '@/src/Search/containers/LocationsSelectFilter';
import PositionsTypeFilter from '@/src/Search/containers/PositionsTypeFilter';
import SpecialtiesFilter from '@/src/Search/containers/SpecialtiesFilter';
import VacanciesSortingFilter from '@/src/Search/containers/VacanciesSortingFilter';
import VacancySalaryRange from '@/src/Search/containers/VacancySalaryRange';

import css from '../styles/FilterRow.module.css';

interface VacanciesFilterProps {
  withoutClinics?: boolean;
}
const VacanciesFilter = ({withoutClinics}: VacanciesFilterProps) => {
  return (
    <>
      <div className={css.withUnderline}>
        <FilterRow>
          <VacanciesSortingFilter />
        </FilterRow>
      </div>

      <div className={css.withUnderline}>
        <FilterRow>
          <JobTypesCheckboxes />
        </FilterRow>
      </div>

      <div className={css.withUnderline}>
        <FilterRow>
          <SpecialtiesFilter />
        </FilterRow>
      </div>

      <div className={css.withUnderline}>
        <FilterRow>
          <PositionsTypeFilter />
        </FilterRow>
      </div>

      <div className={css.withUnderline}>
        <FilterRow>
          <LocationsSelectFilter locationType={LocationTypes.WITH_VACANCY} />
        </FilterRow>
      </div>

      <div className={css.withUnderline}>
        <FilterRow>
          <VacancySalaryRange />
        </FilterRow>
      </div>

      {!withoutClinics && (
        <div className={css.withUnderline}>
          <FilterRow>
            <FilterByClinics />
          </FilterRow>
        </div>
      )}
    </>
  );
};

export default VacanciesFilter;
